import { render, staticRenderFns } from "./UserMyProfile.vue?vue&type=template&id=3cd48bff"
import script from "./UserMyProfile.vue?vue&type=script&lang=js"
export * from "./UserMyProfile.vue?vue&type=script&lang=js"
import style0 from "./UserMyProfile.vue?vue&type=style&index=0&id=3cd48bff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports